import React, { useEffect } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import useTheme from "@material-ui/core/styles/useTheme";
import { reduxForm } from "redux-form";
import { compose } from "recompose";
import Button from "@material-ui/core/Button";
import { surveySelector } from "../../../redux/selectors";
import FormTextField from "../../../components/FormTextField";
import { required } from "../../../utilities/validators";
import { saveSurveyCopy } from "../../../redux/actions";

const requiredValidator = required;

const EditSurveyModal = ({ intl, handleSubmit, save, id }) => {
  const theme = useTheme();

  const onSubmitForm = (values) => {
    save(id, values);
  };

  useEffect(() => {}, []);
  return (
    <form onSubmit={handleSubmit(onSubmitForm)}>
      <Grid
        container
        direction="column"
        justify="flex-start"
        alignItems="center"
        style={{
          width: "75rem",
          padding: "4rem",
          margin: "auto",
          backgroundColor: theme.palette.secondary.main,
        }}
      >
        <Grid item style={{ alignSelf: "center" }}>
          <Typography
            variant="h1"
            style={{
              color: "#fff",
              marginBottom: "25px",
            }}
          >
            {intl.formatMessage({ id: "app.survey.editSurveyModalTitle" })}
          </Typography>
        </Grid>
        <Grid item style={{ alignSelf: "flex-start", width: "100%" }}>
          <FormTextField
            label={
              intl.formatMessage({ id: "app.survey.surveyNamePlaceholder" }) +
              "*"
            }
            fullWidth
            type="text"
            name="title"
            maxLength={254}
            validators={[requiredValidator]}
            variant="filled"
          />
        </Grid>
        <Grid item style={{ alignSelf: "flex-start", width: "100%" }}>
          <FormTextField
            label={intl.formatMessage({
              id: "app.survey.surveyDescriptionPlaceholder",
            })}
            fullWidth
            type="text"
            name="description"
            maxLength={1023}
            variant="filled"
          />
        </Grid>

        <Grid item>
          <Button
            label={intl.formatMessage({ id: "app.survey.editButtonLabel" })}
            style={{
              width: "267px",
              marginTop: "40px",
            }}
            type="submit"
            variant="contained"
            color="primary"
          >
            {intl.formatMessage({ id: "app.surveys.editButtonLabel" })}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state) => ({
  initialValues: surveySelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  save: (id, values) =>
    dispatch(saveSurveyCopy(id, values.title, values.description)),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
  reduxForm({
    form: "editSurvey",
    touchOnChange: true,
    touchOnBlur: true,
  }),
);

export default enhance(EditSurveyModal);
